export default __webpack_public_path__ + "img/sideback-af5ba99f.png";